export const checkIfFocusOnLayer = () => document.activeElement?.classList.contains('focus-layer');
export const checkIfFocusOnBody = () => document.activeElement?.tagName === 'BODY';
export const checkIfFocusOnInput = () => {
  const tagName = document.activeElement?.tagName;
  if (tagName === 'INPUT') return true;
  if (tagName === 'TEXTAREA') return true;
};
